import { assignSafe } from '@summit/core';
import { ISMapPolygon } from './i-map-polygon';

export class SMapPolygonGoogle {
  id: string;
  name: string;
  boundary: { lat: number; lng: number }[];

  constructor(jsonData?: ISMapPolygon) {
    if (jsonData) {
      assignSafe(this, jsonData);
      //TODO add Filter based on Boundary Type;
      if (jsonData.geometry) {
        //console.log(`Boundary is ${jsonData?.boundary?.length} long`)
        if (jsonData.geometry.length > 3) {
          const lastIndex = jsonData.geometry.length - 1;
          if (
            jsonData.geometry[0].latitude == jsonData.geometry[lastIndex].latitude &&
            jsonData.geometry[0].longitude == jsonData.geometry[lastIndex].longitude
          ) {
            jsonData.geometry.pop();
          }
        }
        this.boundary = jsonData?.geometry.map((entry) => ({
          lat: entry.latitude,
          lng: entry.longitude
        }));
      }
    }
  }
}
